import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

// Material Kit 2 React examples
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

//import DesignBlocks from "pages/Presentation/sections/DesignBlocks";
//import Pages from "pages/Presentation/sections/Pages";
//import Testimonials from "pages/Presentation/sections/Testimonials";
//import Download from "pages/Presentation/sections/Download";

// Presentation page components
//import BuiltByDevelopers from "pages/Presentation/components/BuiltByDevelopers";
// Routes
//import routes from "routes";
// Images
import bgImage from "assets/images/strategia.jpg";
import React, { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ALL_SECTIONS, DELETE_SECTION, LOCK_SECTION } from "../queries";
import SectionForm from "./SectionForm";
/* eslint-disable react/prop-types */
const Sectionsadmin = ({ setError, selectedKunta }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  const [sections, setSections] = useState([]);
  const [t] = useTranslation("common");
  const sectionss = useQuery(ALL_SECTIONS, {
    pollInterval: 1000000,
  });
  useEffect(() => {
    let sectionsss = [];
    //let municipalitiess = [];
    if (sectionss.data) {
      sectionsss = sectionss.data.allSections;
      //setOrgans(organss);
      //console.log(sectionsss);
      setSections(sectionsss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sectionss]);
  const [lockSection] = useMutation(LOCK_SECTION, {
    refetchQueries: [{ query: ALL_SECTIONS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });

  const [deleteSection] = useMutation(DELETE_SECTION, {
    refetchQueries: [{ query: ALL_SECTIONS }],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      //setError(error.graphQLErrors[0].message)
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  const setLocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockSection({
      variables: { id: event, active: false },
    });
    //muutetaan activated !actived edituser
  };
  const setUnlocked = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    lockSection({
      variables: { id: event, active: true },
    });
    //muutetaan activated !actived edituser
  };

  const setDelete = async (event) => {
    //event.preventDefault()
    ////console.log(event)
    deleteSection({
      variables: { id: event },
    });
    //muutetaan activated !actived edituser
  };
  return (
    <>
      <MKBox
        minHeight="23vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "2500px 500px",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      />
      <MKBox pt={6} px={1} mt={6}>
        <Container>
          <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="black"
              mt={-6}
              mb={1}
              sx={({ breakpoints, typography: { size } }) => ({
                [breakpoints.down("md")]: {
                  fontSize: size["3xl"],
                },
              })}
            >
              Asiat Admin{" "}
            </MKTypography>
            <MKTypography
              variant="body1"
              color="black"
              textAlign="center"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              {sections.map((section) => (
                <div key={section.id}>
                  <Link to={`/sections/${section.id}`}>{section.header}</Link>
                  <br />
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => setUnlocked(section.id)}
                  >
                    {t("common.unlock")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => setLocked(section.id)}
                  >
                    {t("common.lock")}
                  </Button>
                  <Button
                    style={{
                      backgroundColor: "#07575B",
                      color: "#C4DFE6",
                      fontSize: "14px",
                    }}
                    size="small"
                    type="submit"
                    onClick={() => {
                      if (window.confirm("Haluatko varmasti poistaa asian?")) {
                        setDelete(section.id);
                      }
                    }}
                  >
                    {t("common.delete")}
                  </Button>
                </div>
              ))}
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <SectionForm setError={setError} selectedKunta={selectedKunta} />
    </>
  );
};

export default Sectionsadmin;
